
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacRouterLinkOrA extends Vue {
    @Prop({ default: false }) routerLink!: boolean
    @Prop({ default: '#' }) href!: string
}
